export default function removeCustomFieldItem(this) {
  this.$root.$on('removeCustomFieldItem', (text, type_field) => {
    this.data_repair[type_field] = this.data_repair[type_field].split(',').filter((element) => element.indexOf(text) === -1).join(',').trim();
  });
}
